import { MakeRequest } from './https';
import axiosObject, { authAxios } from './axios';
import { SEQAI_API_BASE_URL } from '../config/seqai';

const seqaiBaseURL = SEQAI_API_BASE_URL.replace(/\/$/, '');

async function seqaiRequest<T = unknown>(req: MakeRequest): Promise<T> {
  const { url, method, data, params, headers, signal, isAuthRequest } = req;
  const axiosInstance = isAuthRequest ? authAxios : axiosObject;
  const res = await axiosInstance({
    url: seqaiBaseURL + url,
    method,
    data,
    params,
    headers,
    signal,
  });
  return res.data as T;
}

export type Citation = {
  source: string;
  page?: number | null;
  section?: string | null;
  url?: string | null;
};

export type KnowledgeQueryResponse = {
  answer: string;
  citations: Citation[];
  insufficient_context: boolean;
  warnings: string[];
  workflow_run_id?: string | null;
};

export type WriteupResponse = {
  title: string;
  content_markdown: string;
  sources: Citation[] | Record<string, unknown>[];
  warnings: string[];
  artifact_id?: string | null;
  workflow_run_id?: string | null;
};

export type PresentationResponse = {
  title: string;
  artifact_id: string;
  download_path: string;
  warnings: string[];
  workflow_run_id?: string | null;
};

export const queryKnowledge = (query: string) =>
  seqaiRequest<KnowledgeQueryResponse>({
    url: '/v1/knowledge/query',
    method: 'post',
    data: { query },
  });

export const createWriteup = (request: string) =>
  seqaiRequest<WriteupResponse>({
    url: '/v1/writeups',
    method: 'post',
    data: { request },
  });

export const createPresentation = (request: string) =>
  seqaiRequest<PresentationResponse>({
    url: '/v1/presentations',
    method: 'post',
    data: { request },
  });

export const getArtifactDownloadUrl = (artifactId: string) =>
  `${seqaiBaseURL}/v1/artifacts/${artifactId}/download`;

export async function downloadArtifact(artifactId: string, filename?: string) {
  const token = localStorage.getItem('accessToken');
  const res = await fetch(getArtifactDownloadUrl(artifactId), {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
  if (!res.ok) {
    throw new Error(`Download failed (${res.status})`);
  }
  const blob = await res.blob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename || `${artifactId}.pptx`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
